import { render, staticRenderFns } from "./CreatePopupKlien.vue?vue&type=template&id=53fdd73c&scoped=true&"
import script from "./CreatePopupKlien.vue?vue&type=script&lang=js&"
export * from "./CreatePopupKlien.vue?vue&type=script&lang=js&"
import style0 from "./CreatePopupKlien.vue?vue&type=style&index=0&id=53fdd73c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fdd73c",
  null
  
)

export default component.exports